import Svg, { Path } from 'react-native-svg'

const NotificationIcon = ({ width = 24, height = 24, color = '#000' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M21 16h-1v-6a8 8 0 0 0-16 0v6H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Zm-9 6a3 3 0 0 0 3-3H9a3 3 0 0 0 3 3Z"
    />
  </Svg>
)
export default NotificationIcon
